import { render, staticRenderFns } from "./bookPnLReport.vue?vue&type=template&id=502fcea4&scoped=true&"
import script from "./bookPnLReport.vue?vue&type=script&lang=js&"
export * from "./bookPnLReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502fcea4",
  null
  
)

export default component.exports